import { NgModule,APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FingerprintjsProAngularModule } from '@fingerprintjs/fingerprintjs-pro-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './modules/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MenuComponent } from './components/menu/menu.component'; 
import { CookieService } from 'ngx-cookie-service';
import { CoreModule } from './modules/core.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LoaderComponent } from './components/loader/loader.component';
import { DateAdapter } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { VideoConferenceModule } from './modules/video-conference.module';
import * as Sentry from "@sentry/angular-ivy";
import { Router } from '@angular/router';
import { MessageModule } from './modules/message.module';

export const MY_FORMATS = {
    parse: {
      dateInput: 'DD/MM/YYYY',
    },
    display: {
      dateInput: 'DD/MM/YYYY',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    }
  };

@NgModule({ declarations: [
        AppComponent,
        MenuComponent,
        LoaderComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        MatDatepickerModule,
        NgbModule,
        CoreModule,
        // StaticModule,
        MessageModule,
        FingerprintjsProAngularModule.forRoot({ loadOptions: {
                apiKey: "ay8BchntcvZ3no7Wz2Ld"
            } }),
        VideoConferenceModule], providers: [CookieService, AsyncPipe, {
            provide: ErrorHandler,
        }, {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        }, provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { 

    constructor(private dateAdapter: DateAdapter<Date>) {
        dateAdapter.setLocale("en-in"); // DD/MM/YYYY
      }

}
